import { Box, Typography } from "@mui/joy";

/**
 * iOS-style segmented control with a sliding thumb.
 *
 * @param root0
 * @param root0.options
 * @param root0.value
 * @param root0.onChange
 * @returns {ReactElement} SegmentedControl
 */
export function SegmentedControl({
  options,
  value,
  onChange,
}: {
  options: string[];
  value: number;
  onChange: (index: number) => void;
}) {
  return (
    <Box
      sx={{
        position: "relative",
        // Equal-width columns sized by the widest label, so the sliding
        // thumb always lines up and no label gets clipped.
        display: "inline-grid",
        gridAutoFlow: "column",
        gridAutoColumns: "1fr",
        background: "rgba(120, 120, 128, 0.12)",
        borderRadius: "10px",
        p: "2px",
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 2,
          bottom: 2,
          left: 2,
          width: `calc((100% - 4px) / ${options.length})`,
          transform: `translateX(${value * 100}%)`,
          transition: "transform 0.25s cubic-bezier(0.3, 0, 0.2, 1)",
          background: "var(--mui-palette-background-paper, #fff)",
          borderRadius: "8px",
          boxShadow:
            "0 1px 4px rgba(0, 0, 0, 0.12), 0 0.5px 1px rgba(0, 0, 0, 0.06)",
        }}
      />
      {options.map((option, i) => (
        <Box
          key={option}
          onClick={() => onChange(i)}
          sx={{
            position: "relative",
            zIndex: 1,
            textAlign: "center",
            px: 2.5,
            py: 0.5,
            cursor: "pointer",
            userSelect: "none",
            whiteSpace: "nowrap",
          }}
        >
          <Typography
            level="body2"
            sx={{
              fontWeight: value === i ? 600 : 500,
              fontSize: "0.8125rem",
              color: "var(--mui-palette-text-primary)",
            }}
          >
            {option}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
